import { LogoImageSvg } from 'components/Logo';

import * as S from './styled';

export const PageLoader = () => (
    <S.Container $backgroundColor="surface-main">
        <LogoImageSvg />
    </S.Container>
);
